import { AdvancedTitle } from '../../interfaces/advanced-title.interface';
import { Component, OnInit } from '@angular/core';
import { TitleConfigService } from '../../services/title-bar-configuration.service';

@Component({
  selector: 'nli-title-bar',
  templateUrl: './nli-title-bar.component.html',
  styleUrls: ['./nli-title-bar.component.css']
})
export class NliTitleBarComponent implements OnInit {
  mainTitle: AdvancedTitle[] = [{ title: '' }];
  subTitle: AdvancedTitle[] = [{ title: '' }];

  constructor(private titleConfigService: TitleConfigService) {}

  ngOnInit() {
    this.mainTitle = this.titleConfigService.mainTitle;
    this.titleConfigService.mainTitle$.subscribe(mainTitle => {
      this.mainTitle = mainTitle || this.mainTitle;
    });
    this.subTitle = this.titleConfigService.subTitle;
    this.titleConfigService.subTitle$.subscribe(subTitle => {
      this.subTitle = subTitle || this.subTitle;
    });
  }
}
